var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"report__page"},[_c('h2',[_vm._v("Report Details")]),(_vm.isLocationReport)?_c('ReportDetailsSelector',{attrs:{"details":_vm.customDetailsLocations,"is-compact":true}}):_c('ReportDetailsSelector',{attrs:{"details":_vm.customDetailsAssets,"is-compact":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }